import { render, staticRenderFns } from "./DirectChatManager.vue?vue&type=template&id=e6622140&scoped=true&"
import script from "./DirectChatManager.vue?vue&type=script&lang=js&"
export * from "./DirectChatManager.vue?vue&type=script&lang=js&"
import style0 from "./DirectChatManager.vue?vue&type=style&index=0&id=e6622140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6622140",
  null
  
)

export default component.exports